// Modelo Compañia para administrador.
export default class Sale {
    id=""
    cliente=""
    dispositivos=""
    valor=""
    iva=""
    valorTotal=""
    retencion=""
    valorTotalRetencion=""
    formaPago=""
    abono=""
    saldo=""
    responsable=""
    cuotas=""
    cuotasLista=[]
    gananciaInstalador=""
    gananciaResponsable=""
    gananciaPremios=""
    numeroFactura=""
    observaciones=""
}



// WEBPACK FOOTER //
// ./src/model/Sale.js